import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { AMC_ADVERTISER_TYPE, type AmcAdvertiser } from "../../../zodios/apiDefinitions/amc";
import { useAppSelector } from "../../../redux/hooks";
import { useAMCInstance } from "./useAMCInstance";

const emptyAdvertisers: AmcAdvertiser[] = [];

export function useAmcAdvertisers() {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { data: instance, isLoading: isInstanceLoading } = useAMCInstance();

  const instanceId = instance?.instance_id;

  const query = useQuery({
    queryKey: ["amcInstanceAdvertisers", instanceId, marketPlace],
    queryFn: async () =>
      await apiClient.getAMCInstanceAdvertisers({
        queries: { instance_id: instanceId!, marketplace: marketPlace },
      }),
    enabled: !!instanceId && !!marketPlace,
  });

  const advertisers = query.data?.advertisers ?? emptyAdvertisers;

  const { sponsoredAds, dsp, byId } = useMemo(
    () => ({
      sponsoredAds: advertisers.filter((a) => a.type === AMC_ADVERTISER_TYPE.sponsoredAds),
      dsp: advertisers.filter((a) => a.type === AMC_ADVERTISER_TYPE.display),
      byId: new Map(advertisers.map((a) => [a.id, a])),
    }),
    [advertisers],
  );

  return {
    advertisers,
    sponsoredAds,
    dsp,
    byId,
    instance,
    isLoading: isInstanceLoading || query.isLoading,
    isError: query.isError,
    hasNoInstance: (!isInstanceLoading && !instanceId) || query.data?.amc_instance_missing === true,
  };
}
